








import { Vue, Component } from 'vue-property-decorator';
import { vxm } from '@/store';

@Component
export default class extends Vue {
  async mounted() {
    const ticket = this.$route.query.ticket as string;
    if (ticket) {
      await vxm.login.getTokenFromTicket(ticket);
    }
  }
}
